import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDevDependency = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 13,
	viewBox: "0 0 18 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M16.9205 0.627319H6.07233C5.71675 0.627319 5.42948 0.914596 5.42948 1.27018V6.01125H0.688405C0.332824 6.01125 0.0455475 6.29853 0.0455475 6.65411V12.1184C0.0455475 12.474 0.332824 12.7612 0.688405 12.7612H11.5366C11.8922 12.7612 12.1795 12.474 12.1795 12.1184V7.37732H16.9205C17.2761 7.37732 17.5634 7.09004 17.5634 6.73446V1.27018C17.5634 0.914596 17.2761 0.627319 16.9205 0.627319ZM6.79555 1.99339H10.8134V6.01125H6.79555V1.99339ZM5.42948 11.3952H1.41162V7.37732H5.42948V11.3952ZM10.8134 11.3952H6.79555V7.37732H10.8134V11.3952ZM16.1973 6.01125H12.1795V1.99339H16.1973V6.01125Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgDevDependency);
export { ForwardRef as ReactComponent };
